<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div :class="backgroundClasses" class="rounded-md p-4 m-4 sm:m-0 sm:mt-4 mt-4">
        <div class="flex">
            <div class="shrink-0">
                <CheckCircleIcon v-if="type == 'success'" :class="iconClasses" class="h-5 w-5" aria-hidden="true" />
                <InformationCircleIcon v-else-if="type == 'info'" :class="iconClasses" class="h-5 w-5" aria-hidden="true" />
                <ExclamationIcon v-else-if="type == 'warning'" :class="iconClasses" class="h-5 w-5" aria-hidden="true" />
                <XCircleIcon v-else-if="type == 'danger'" :class="iconClasses" class="h-5 w-5" aria-hidden="true" />
            </div>
            <div class="ml-3">
                <h3 :class="titleClasses" class="text-sm font-medium">
                    <slot name="title" />
                </h3>
                <div :class="messageClasses" class="mt-2 text-sm">
                    <p>
                        <slot name="message" />
                    </p>
                </div>
            </div>
            <div v-if="dismiss" class="ml-auto pl-3">
                <div class="-mx-1.5 -my-1.5">
                    <button type="button" :class="buttonClasses" class="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2">
                        <span class="sr-only">Dismiss</span>
                        <XIcon class="h-5 w-5" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { CheckCircleIcon, InformationCircleIcon, ExclamationIcon, XCircleIcon, XIcon } from '@heroicons/vue/solid'

export default {
    props: ['type', 'dismiss'],

    components: {
        CheckCircleIcon,
        InformationCircleIcon,
        ExclamationIcon,
        XCircleIcon,
        XIcon,
    },

    computed: {

        backgroundClasses() {

            if (this.type == 'success') {
                return 'bg-green-50 transition duration-500 ease-in-out dark:bg-gray-900'
            }

            if (this.type == 'info') {
                return 'bg-blue-50 transition duration-500 ease-in-out dark:bg-gray-900'
            }

            if (this.type == 'warning') {
                return 'bg-yellow-50 transition duration-500 ease-in-out dark:bg-gray-900'
            }

            if (this.type == 'danger') {
                return 'bg-red-50 transition duration-500 ease-in-out dark:bg-gray-900'
            }

        },

        iconClasses() {

            if (this.type == 'success') {
                return 'text-green-400 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'info') {
                return 'text-blue-400 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'warning') {
                return 'text-yellow-400 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'danger') {
                return 'text-red-400 transition duration-500 ease-in-out dark:text-white'
            }

        },

        titleClasses() {

            if (this.type == 'success') {
                return 'text-green-800 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'info') {
                return 'text-blue-800 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'warning') {
                return 'text-yellow-800 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'danger') {
                return 'text-red-800 transition duration-500 ease-in-out dark:text-white'
            }

        },

        messageClasses() {

            if (this.type == 'success') {
                return 'text-green-700 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'info') {
                return 'text-blue-700 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'warning') {
                return 'text-yellow-700 transition duration-500 ease-in-out dark:text-white'
            }

            if (this.type == 'danger') {
                return 'text-red-700 transition duration-500 ease-in-out dark:text-white'
            }

        },

        buttonClasses() {

            if (this.type == 'success') {
                return 'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600 transition duration-500 ease-in-out dark:text-white dark:bg-gray-800'
            }

            if (this.type == 'warning') {
                return 'bg-yellow-50 text-yellow-500 hover:bg-yellow-100 focus:ring-offset-yellow-50 focus:ring-yellow-600 transition duration-500 ease-in-out dark:text-white dark:bg-gray-800'
            }

            if (this.type == 'info') {
                return 'bg-blue-50 text-blue-500 hover:bg-blue-100 focus:ring-offset-blue-50 focus:ring-blue-600 transition duration-500 ease-in-out dark:text-white dark:bg-gray-800'
            }

            if (this.type == 'danger') {
                return 'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600 transition duration-500 ease-in-out dark:text-white dark:bg-gray-800'
            }

        }

    }
}

</script>
